// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sqWg","newExpiryDate":"styles_newExpiryDate__3DoVi","footer":"styles_footer__2flE2"};